export default {

    /**
     * Get tasks list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getList: state => ({task_id, user_type}) => {

        // Return tasks list
        return Object.values(state.taskusers).filter((ut) => (ut.user_type == user_type && ut.task_id == task_id && !ut.deleted_at));
    },

    /**
     * Get all items
     * @param state
     * @returns {default.campaigns|{}}
     */
    getAll: state => {

        // Return tasks list
        return Object.values(state.taskusers);
    },

    /**
     * Get user tasks roles
     * @param state
     * @returns
     */
    getUserRoles: state => ({task_id, user, role}) => {

        // Convert to array
        if(!Array.isArray(role)) role = [role];

        // Check each item
        return Object.values(state.taskusers).filter((ut) => {

            // check task
            if(ut.task_id == task_id && !ut.deleted_at) {

                // Check for item
                for(const rl of role) {
                    // Check conditions
                    if(
                        (!rl || ut.user_type == rl) &&
                        (rl && rl.indexOf("_position") !== -1 ? user.positions.includes(ut.user_id) : ut.user_id == user.id)
                    ) return true;
                }
            }

            // Not fit
            return false;
        });
    },

    /**
     * Check users parent role
     * @returns
     */
    checkUserParentRoles: () => ({task_id, user, role}) => {

        // Process parents
        for(const tId of window.app.$get('tree/getTasksParents', task_id)) {
            if(window.app.$get('taskuser/getUserRoles', {task_id:tId, user, role}).length) return true;
        }

        // Not fit
        return false;
    },

    /**
     * Get user tasks roles list
     * @param state
     * @returns
     */
    getUserRolesList: state => (task_id) => {
        // Return roles
        return state.taskIndex[task_id] ? state.taskIndex[task_id] : {};
    },

    /**
     * Get tasks by role
     * @param state
     * @returns
     */
    getTasksByRoles: state => ({user, role}) => {
        return Object.values(state.taskusers).filter((ut) => (
            !ut.deleted_at &&
            ut.user_type == role &&
            (role.indexOf("_position") !== -1 ? user.positions.includes(ut.user_id) : ut.user_id == user.id)
        ));
    },

    /**
     * Has roles
     * @param state
     * @returns
     */
    hasRoles: state => ({task_id, role}) => {
        return Object.values(state.taskusers).filter((ut) => (
            ut.task_id == task_id &&
            !ut.deleted_at &&
            ut.user_type == role
        ));
    },

    /**
     * Get taskuser by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getByID: state => (id) => {
        // Return taskuser list
        return state.taskusers[id];
    }

}
